import React from 'react'

import { findDOMNode } from 'react-dom'
import HintPopover from "../../../gd-ui/hint-popover/hint-popover"
import Popover from "../../gd-popover/popover-v2"
import PopoverPosition from "../../gd-popover/popover-position"
import {PopoverAttachmentType} from "../../gd-popover/@const"

// use .show-popover class to keep visible when popup menu open !!!!
type Props = {

    className?                  : string
    style?                      : style
    children?                   : any

    btnComponent?               : {(state: any, props: any): any}   // pass component if icon class is not enough
    menuComponent               : func | any                        // component with menu - skin gd-popup-menu-btn
    menuParams?                 : any                               // menu component params - vaznaya shtuka (!) dlya handlers ?
    hint?                       : string                            // optional hint for the btnComponenr

    popoverClass?               : string,
    popoverContentClass?        : string,
    popoverStyles?              : any,
    popoverContentStyles?       : any
    domElementId?               : string,              // set dom element id used in tour

    position?                   : PopoverPosition          // takes precedence over attachment/targetAttachment/attachmentType/offset below
    attachment?                 : string,
    targetAttachment?           : string,
    attachmentType?             : 'horizontal' | 'vertical'
    offset?                     : string,
    arrowsVersion?              : 1|2
    arrowPointOffset?           : string           // "dy dx" in px — fine-tunes arrow tip position, e.g. "4 0"

    outsideClickIgnoreClasses?  : any,     // string or array of strings, nodes classes clicks on which are ignored
    insideClickIgnoreClasses?   : any     // string or array of strings, nodes classes clicks on which are ignored
    clickOutsideDelay?          : number

    disabled?                   : boolean                     // if true - no click + disabled class

    showPopover?                : boolean             // if true - popover shown by default used when multiselect in popover (checkboxes)

    // callback
    onTogglePopover?            : {(showPopover: boolean, component: any): void}

}

type State = {
    showPopover : boolean
}

export default class PopupMenuButton extends React.Component<Props,State> {

    public popoverKeyDownListener?      : any // need fix potom

    static defaultProps = {
        disabled        : false,
        attachment      : "top right",
        targetAttachment: "bottom right",
        attachmentType  : "horizontal",
        offset          : "0 -10",
        arrowsVersion   : 2,

        // If clicking via the touchpad doesn't work, it means the `onClick` event isn't triggering in time.
        // In this case, you need to increase `clickOutsideDelay` to allow it enough time to fire.
        clickOutsideDelay   : 300
    }

    constructor(props:Props) {
        super(props)

        this.state = {
            showPopover: !!(this.props.showPopover)
        }
    }

    preventPropagation = (e:React.SyntheticEvent) => {
        e.stopPropagation()
    }

    onPopoverKeyDown = (e:React.SyntheticEvent) => {
        this.popoverKeyDownListener?.onPopoverKeyDown(e);
    }

    onClickOutside = (e?:React.SyntheticEvent) => {
        if(e
            && this.props.outsideClickIgnoreClasses
            && gd.utils.Dom.findNodeByClassName(e.target, this.props.outsideClickIgnoreClasses)
        ) {
            return
        }

        this.hidePopover()
    }

    hidePopover = () => {
        this.setState({
            showPopover: false
        }, ()=>{
            this.props.onTogglePopover?.(false, this)
        })
    }

    togglePopover = (e:React.SyntheticEvent) => {
        e.stopPropagation()

        if (this.props.disabled) {
            return
        }

        if(
            this.props.insideClickIgnoreClasses
            && gd.utils.Dom.findNodeByClassName(e.target, this.props.insideClickIgnoreClasses)
        ) {
            return
        }

        const showPopover = !this.state.showPopover
        this.setState({
            showPopover: showPopover
        },()=>{
            this.props.onTogglePopover?.(showPopover, this)
        })
    }

    onPopoverKeyDownListener = (listener:callback) => {
        this.popoverKeyDownListener = listener;
    }

    // legacy attachment props map 1:1 onto PopoverPosition (v1 Popover passed `offset` as tether `offset`, same here)
    popoverPosition = () => {
        return this.props.position || new PopoverPosition({
            attachment          : this.props.attachment!,
            targetAttachment    : this.props.targetAttachment!,
            attachmentType      : this.props.attachmentType as PopoverAttachmentType,
            targetOffset        : "0 0",
            offset              : this.props.offset,
        })
    }

    renderPopover = () => {
        const MenuComponent = this.props.menuComponent

        return (
            <Popover
                popoverClass        = {Classes("gd-popup-menu", this.props.popoverClass)}
                className           = {this.props.popoverContentClass}
                style               = {this.props.popoverStyles}
                popoverContentStyle = {this.props.popoverContentStyles}
                position            = {this.popoverPosition()}
                arrowsVersion       = {this.props.arrowsVersion}
                arrowPointOffset    = {this.props.arrowPointOffset}
                onKeyDown           = {this.onPopoverKeyDown}
                onClickOutside      = {this.onClickOutside}
                clickOutsideDelay   = {this.props.clickOutsideDelay}
                getTargetFunc       = {()=>findDOMNode(this)}
            >

                <MenuComponent
                    hidePopover                 = {this.hidePopover}
                    menuParams                  = {this.props.menuParams}
                    onPopoverKeyDownListener    = {this.onPopoverKeyDownListener}
                />

            </Popover>
        )
    }

    render() {
        const classes = Classes("gd-popup-menu-btn", this.props.className, {
            "show-popover"  : this.state.showPopover,
            'disabled'      : this.props.disabled,
        })

        return (
            <div id         = {this.props.domElementId}
                 className  = {classes}
                 style      = {this.props.style}
                 onClick    = {this.togglePopover}
            >
                {this.props.btnComponent?.(this.state, this.props)}
                {this.props.children}
                {this.props.hint && !this.state.showPopover &&
                    <HintPopover hint={this.props.hint}/>
                }
                {this.state.showPopover && this.renderPopover()}
            </div>
        )
    }
}

